<!--
  * @Description: 共享网络课程 修改
  * @Author: PF
  * @Date: 2023-08-28 16:01:43.947
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-10-27 11:52:55
-->
<template>
  <div>
    <el-dialog class="w500 h300" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="推荐顺序" prop="tjsx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input-number v-model="ruleForm.tjsx" :min="0" :precision="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import { submitEditForm, closeWindow, loadData, actionPost } from '@/api/common.js'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})

watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadData({
        url: '/api/v2/wangluojiaoxue/wangluokecheng/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)

// 保存
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  actionPost({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/tuijianshunxu',
    data: {
      tjsx: ruleForm.value.tjsx,
      wlkcid: props.row.id
    }
  }).then((res) => {
    if (res.code === 200) {
      emits('ReturnData')
      handleClose()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 关闭
const handleClose = () => {
  emits('update:openEdit', false)
}

</script>
